import React, { Component } from 'react';
import { inject, observer } from "mobx-react/index";
import { Fechar } from '../../comum/components/Icones'

@inject("store")

@observer
export default class CardAtencao extends Component {
    constructor(props) {
        super(props);

        this.state = {
            alerta: !this.props.controller || typeof (this.props.controller.alerta) !== "boolean" ? true : this.props.controller.alerta
        }
        this.isBotaoFechar = typeof (this.props.isBotaoFechar) === "boolean" || props.isBotaoFechar ? true : false;
        this.classLabel = this.props.classLabel ? this.props.classLabel : "";
    }

    componentDidUpdate = (prevProps) => {
        if (this.props.controller && this.state.alerta !== this.props.controller.alerta)
            this.setState({ alerta: this.props.controller.alerta });
    }

    fecharAlerta = () => {
        if (this.props.controller)
            this.props.controller.alerta = false;
        this.setState({ alerta: false });
    }

    render() {
        return (
            this.state.alerta &&
                <div className="card-atencao float-right">
                    <div className="d-flex w-100 justify-content-between align-items-center pb-2">
                        <div className="card-atencao--title">{this.props.title ? this.props.title : "ATENÇÃO!"}</div>
                        {
                            this.isBotaoFechar &&
                            <Fechar tamanho="1x" className="card-atencao--close" onClick={() => this.fecharAlerta()} />
                        }
                    </div>
                    <div className={this.classLabel}>
                        {this.props.conteudo}
                        {this.props.children}
                    </div>
                </div>
            )
    }
}


// WEBPACK FOOTER //
// ./src/modules/comum/components/CardAtencao.js